/**
 * Internally managed in a few places:
 * - client/libs/monolith/shared/src/lib/customer/redux/cart.ts
 * - client/libs/shared-ecomm/types/src/lib/analyticsEvent.ts
 * @see https://docs.iheartjane.com/jane-docs/implementing-roots/embedding-checkout#client-side-event-callbacks
 */
export enum HeadlessCartEvents {
  CartItemAdd = 'cartItemAdd',
  CartItemChangeCount = 'cartItemChangeCount',
  CartItemRemoval = 'cartItemRemoval',
  CartPageLoad = 'cartPageLoad',
  ChangeStore = 'changeStore',
  Checkout = 'checkout',
  ContinueShopping = 'drawerContinueShopping',
  DrawerClosed = 'drawerClosed',
  HeadlessAppLoaded = 'headlessAppLoaded',
  InitiateExternalAuth = 'initiateExternalAuth',
  NavigateToBrandSpecial = 'navigateToBrandSpecial',
  NavigateToProduct = 'navigateToProduct',
}
